import { type ChangeEvent, useEffect, useState } from 'react'

import { onCheckDisabledConditions } from '@/app/utils'

interface IField {
    name: string
    value: string
    placeholder: string
    error: string | null
    isTouched: boolean
}

export const useFields = () => {
    const initialName = {
        name: 'name',
        value: '',
        placeholder: 'Наименование раздела',
        error: null,
        isTouched: false
    }

    const [name, setName] = useState<IField>(initialName)

    useEffect(() => {
        if (!name.value.length) {
            setName((prev) => ({ ...prev, error: 'Обязательное поле' }))
        } else {
            setName((prev) => ({ ...prev, error: null }))
        }
    }, [name.value])

    const onInitializeFields = () => {
        setName(initialName)
    }

    const onChangeName = (e: ChangeEvent<HTMLInputElement>) => setName((prev) => ({ ...prev, value: e.target.value }))
    const onTouchName = () => setName((prev) => ({ ...prev, isTouched: true }))
    const onZeroName = () => setName((prev) => ({ ...prev, value: '' }))
    const nameError = name.isTouched && name.error ? name.error : null
    const isValidFields = onCheckDisabledConditions(Boolean(!name.error), Boolean(name.isTouched))

    return {
        name,
        nameError,
        onChangeName,
        onTouchName,
        onZeroName,
        isValidFields,
        onInitializeFields
    }
}
